import React, { Component } from "react";
import { Select } from "antd";
import moment from "moment";

class YearPicker extends Component {
  handleChange = value => {
    this.props.onChange(value);
  };

  render() {
    const currentYear = moment.unix(new Date().getTime() / 1000).format("YYYY");
    const years = [];
    for (let i = -1; i < 4; i++) {
      years.push(currentYear - i);
    }
    return (
      <Select
        onChange={this.handleChange}
        style={{ ...this.props.style }}
        defaultValue={this.props.value || this.props.defaultValue}
        placeholder="请选择年份"
      >
        {years.map(item => (
          <Select.Option key={item}>{item}</Select.Option>
        ))}
      </Select>
    );
  }
}
export default YearPicker;



// WEBPACK FOOTER //
// ./src/components/comm/YearPicker.js